<template>
  <span class="cart-count">
    <span class="cart-count__icon">
      <icon name="cart" />
      <span class="cart-count__value">
        {{ cartItemsCount }}
      </span>
    </span>
    <span class="cart-count__title">
      {{ $t("event.servicesOrder.servicesCartBtn") }}
    </span>
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CartCountComponent",
  computed: {
    ...mapGetters("services", ["cartServicesList"]),

    cartItemsCount() {
      return this.cartServicesList.length || 0;
    }
  }
};
</script>

<style lang="scss">
.cart-count {
  display: flex;
  align-items: center;
  color: var(--white, #fff);

  &__title {
    margin-left: 10px;
  }

  &__icon {
    position: relative;
    display: flex;

    .svg-icon {
      margin: 0;
      width: 20px;
      height: 20px;
    }
  }

  &__value {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%, -35%);
    color: var(--main, #009ee3);
    background: var(--white, #fff);
    border-radius: 50%;
    min-width: 15px;
    height: 15px;
    padding: 1px;
    font-size: 9px;
    font-weight: 500;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
}
</style>
